import * as Utils from "../helpers/utils";
import * as CONST from "../const/action.const.js"

const initialState = {
  isLogged: Utils.getToken && Utils.getRole  ? true : false,
  user_token: Utils.getToken ? Utils.getToken : null,
  user_userName: Utils.getToken ? null : null,
  user_role: Utils.getToken ? Utils.getRole : null,
  user_permissions: Utils.getToken ? Utils.getPermissions : null,
  user_type_of_account: Utils.getToken ? Utils?.getTypeOfAccount : null,
  user_full_name: Utils.getToken ? Utils.getFullName : null,
  username_generated: null,
  password_generated: null,
}

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  console.log("action auth", action)
  console.log("payload auth", payload)
  console.log("process.env.REACT_APP_apiKey", process.env.REACT_APP_apiKey)
  switch (type) {
    case CONST.LOGIN_SUCCESS:
      return {
        ...state,
        isLogged: true,
        user_userName: null,
        user_token:payload.token,
        user_role: payload.role,
        user_permissions: payload.permissions,
        user_type_of_account: payload.type_of_account,
        user_full_name: payload.name
      };
    case CONST.LOGIN_FAILURE:
      return {
        ...state,
        isLogged: false,
        user_userName: null,
        user_role: null,
      };
    case CONST.CHECK_USER_LOGGED_SUCCESS:
      return {
        ...state,
        isLogged: true,
        user_userName:null,
        user_role: payload.role,
      };
    case CONST.CHECK_USER_LOGGED_FAILURE:
      return {
        ...state,
        isLogged: false,
        user_userName: null,
        user_role: null,
      };
    case CONST.LOGOUT:
      return {
        ...state,
        isLogged: false,
        user_userName: null,
        user_role: null,
        username_generated: null,
        password_generated: null,
      };
    case CONST.GENERATE_USERNAME_SUCCESS:
      return {
        ...state,
        username_generated: payload,
      };
    case CONST.GENERATE_USERNAME_FAILURE:
      return {
        ...state,
        username_generated: null,
      };
    case CONST.GENERATE_PASSWORD_SUCCESS:
      return {
        ...state,
        password_generated: payload,
      };
    case CONST.GENERATE_PASSWORD_FAILURE:
      return {
        ...state,
        password_generated: null,
      };
    default:
      return state;
  }
}
